export const CDN_BASE_URL = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/MACRO/templates/macro-saca-tu-tarjeta`;
